import Vue from "vue";

Vue.mixin({
  methods: {
    showErrorDialog(error) {
      this.$store.dispatch("setErrorDialog", error);
    },
    hideErrorDialog() {
      this.$store.dispatch("setErrorDialog", null);
    },
    showConfirmDialog(confirm) {
      this.$store.dispatch("setConfirmDialog", confirm);
    },
    hideConfirmDialog() {
      this.$store.dispatch("setConfirmDialog", null);
    },
    showResultDialog(result) {
      this.$store.dispatch("setResultDialog", result);
    },
    hideResultDialog() {
      this.$store.dispatch("setResultDialog", null);
    },
    showLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", 1);
    },
    hideLoading() {
      this.$store.dispatch("increaseLoadingReqNumber", -1);
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/dialog.js